import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { Checkbox } from '@crazyegginc/hatch';

import { AUDIENCE_METADATA } from '../../../metadata';
import { ConditionTooltip } from '../ConditionTooltip';

export function CheckBoxValue({ index, innerIndex }) {
  const { values, errors, touched, setFieldValue } = useFormikContext();
  const condition = values.conditions[index];
  const { criteria, rows } = condition;
  const row = rows[innerIndex];
  const v = row.values;
  const showTooltip = row.tooltip === 'value';
  const isTouched = touched?.conditions?.[index]?.rows?.[innerIndex]?.values;
  const error = errors?.conditions?.[index]?.rows?.[innerIndex]?.values;
  const isError = isTouched && error;

  const metadata = AUDIENCE_METADATA[criteria];
  const { options } = metadata;

  function onTooltipDismiss() {
    setFieldValue(`conditions[${index}].rows[${innerIndex}].tooltip`, false, false);
  }

  const handleChange = (valueToChange) => {
    let newValue = [...v];
    if (v.includes(valueToChange)) {
      newValue = newValue.filter((i) => i !== valueToChange);
    } else {
      newValue = [...newValue, valueToChange];
    }
    if (showTooltip) {
      onTooltipDismiss();
    }
    setFieldValue(`conditions[${index}].rows[${innerIndex}].values`, newValue);
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-wrap gap-y-2.5">
        {options.map(({ label, value, icon: Icon }, i) => {
          const checked = v.includes(value);
          const option = (
            <div
              key={value}
              className={classNames('mr-2.5 flex h-[35px] items-center rounded border px-2.5', {
                'border-mystic-500': !isError && !checked,
                'border-dodger-blue-500': !isError && checked,
                'border-carnation-500': isError,
                'bg-solitude-500': checked,
                'bg-white': !checked,
              })}
            >
              <Checkbox
                onChange={() => handleChange(value)}
                checked={checked}
                id={label}
                label={
                  <div className="flex items-center justify-center">
                    {Icon ? (
                      <Icon
                        className={classNames('fill-current w-4 h-4 mr-1.25', {
                          'text-dodger-blue-500': checked,
                          'text-cadet-blue-500': !checked,
                        })}
                      />
                    ) : null}
                    <span
                      className={classNames({
                        'text-dodger-blue-500': checked,
                        'text-black-pearl-500': !checked,
                      })}
                    >
                      {label}
                    </span>
                  </div>
                }
              />
            </div>
          );

          return (
            <ConditionTooltip
              criteria={metadata}
              key={value}
              show={showTooltip && i === options.length - 1}
              onDismiss={onTooltipDismiss}
            >
              {option}
            </ConditionTooltip>
          );
        })}
      </div>
      {isError && <div className="text-body-4 whitespace-nowrap text-carnation-500">{error}</div>}
    </div>
  );
}
